import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import Price from "components/Price/Price"
import { observer } from "mobx-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore";
import CouponInput  from "components/Cart/CouponInput";



@observer
class CartTotal extends Component {
  
  componentDidMount() {
    shop.cart.update()
  }
  
  render() {
    const { showTax, fluid, className = "" } = this.props
    let { brutto, tax, size, sumDiscount,products } = shop.cart
    //console.log("CART TOTAL: ", shop.cart.products)
    let sum = 0
    let sumcount = 0
    for (let i = 0; i < products.length; i++) {
      //console.log("PRODUCTS: ", products[i].extras.trueReturnValue,"SUM: in for", sum, "prouct count in for: ", products[i].count)
      sum += products[i].price * (products[i].count)
      sumcount += products[i].count
    }
    //console.log("SUM: ", sum)

    return (
      /*<Table style={{horizontalAlign: "right" ,paddingRight: "30%",maxWidth: `${fluid ? "80%" : "320px"}` }} className={`CartTotal pr5 ${className}`}>
        <thead>
        {cmsStore.config.plugin.coupons &&
        <tr>
          <td colSpan={2}>
            <CouponInput/>
          </td>
        </tr>}
        <tr className="pr5">
          <td><strong>{translate( "Summe" )}</strong></td>
          <td className="tr"><Price>{sum}</Price></td>
        </tr>
        
        {showTax &&
        <tr>
          <td><strong>{translate( "MwSt." )}</strong></td>
          <td className="tr"><Price>{tax}</Price></td>
        </tr>
        }
        
        {shop.config.useTaxNotice && <tr>
          <td colSpan={2}>
            <shop.config.useTaxNotice/>
          </td>
        </tr>}
        
        {showTax &&
        <tr>
          <td><strong>{translate( "Brutto" )}</strong></td>
          <td className="tr"><Price>{brutto}</Price></td>
        </tr>
        }
        
        
        {(shop.session.handId && !!sumDiscount) &&
        <React.Fragment>
          <tr className={"black-60 f5"}>
            <td>{translate( "Discount" )}</td>
            <td className="tr"><Price>{sumDiscount}</Price></td>
          </tr>
          
          <tr>
            <td><strong>{translate( "nach Rabatt" )}</strong></td>
            <td className="tr"><Price>{sum - sumDiscount}</Price></td>
          </tr>
        </React.Fragment>
        }
        
        </thead>
      </Table>*/
      <React.Fragment>
        <a className="fw7" style={{color:"black", fontSize:16}}>{sumcount}</a>
      </React.Fragment>

    )
  }
}

CartTotal.propTypes = {
  sum : PropTypes.number,
  size: PropTypes.number,
}

export default CartTotal



// WEBPACK FOOTER //
// ./src/theme/lindt/components/Cart/CartTotal.js